import React from "react"
import ModalV4 from "../../../../app/ui/modal/v4/v4"
import ProjectFinder from "../../../gd-components/finder/project/project-finder"
import ProjectSession from "../../../model2/project/project-session";
import {EntityType} from "../../../gd/const/item";

type Props = {
    params: {
        projectId   : string
        entityType  : EntityType
        onSubmit    : func
    }
}

// const debug = "ModalProjectLink"
const debug = false

export default class ModalProjectLink extends ModalV4 {

    onClickProject = (projectId: ID) => {
        const project = gd.session.projects.get(projectId)
        debug && console.log(debug, 'onClickProject', project)
        project && this.props.params.onSubmit?.({
            id      : project.id,
            name    : project.name,
            type    : 'project',
            data    : project
        })
    }

    render() {
        return (
            <div className="v4-container placement-middle" onClick={this.stopPropagation}>
                <ProjectFinder parentProjectId  = {this.props.params.projectId}
                               parentsFor       = {this.props.params.entityType}
                               onClickProject   = {this.onClickProject}
                               onClose          = {this.closeModal}/>
            </div>
        );
    }
}